import IStopDataReport from '@/models/reports/stop-data.report'
import { MapsUtil } from '@/utils/maps.util'
import BasePopup from '../base.popup'

export default class StoppingPopup implements BasePopup {
    data: IStopDataReport
    icon: string
    offSet = [0, -37]

    constructor(feature: any) {
        this.data = feature.get('data')
        this.icon = feature.get('icon')
    }
    getParamsAddress(): { id: string; lat: number; lon: number } {
        return {
            id: `stop_${this.data.index}`,
            lat: this.data.latitude,
            lon: this.data.longitude,
        }
    }

    getContent(): string {
        const device = this.data.report.device
        return `
        <div class="cajatitle">
            <img src=${require('@/assets/img/pointers/' + this.icon + '.png')} >
            <p class="m-0 ms-1 fw-bold fs-6">${this.data.title}</p>
        </div>
        <hr >
        <div class="lineas align-items-center">
            <p class="propiedad m-0">Unidad: </p>
            <p class="valor m-0 ms-1">
                <img class="w-auto p-0" style="height: 25px" src=${require('@/assets/img/devices/' +
                    device.icon +
                    '.png')} >
                ${device.plate}
            </p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Inicio: </p>
            <p class="valor m-0 ms-1">${this.data.startDate}</p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Fin: </p>
            <p class="valor m-0 ms-1">${this.data.endDate}</p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Duración: </p>
            <p class="valor m-0 ms-1">${this.data.duration}</p>
        </div>
        <div class="lineas">
            <p class="propiedad m-0">Dirección: </p>
            <p class="valor m-0 ms-1" id="stop_${this.data.index}"></p>
        </div>
        <div class="lineas">
            <a class="link" href="${MapsUtil.getGoogleMapsURL(
                this.data?.latitude,
                this.data?.longitude
            )}" target="_blank" rel="noopener noreferrer">Link Google Maps</a>
        </div>
        `
    }
}
